import Slider from './slider'

export default Slider



// WEBPACK FOOTER //
// ./components/vc-slick/src/index.js